import { Chunk } from './Chunk'

export class Chunker {
  chunks: Chunk[] = []

  add(blob: Blob) {
    this.chunks.push(new Chunk(this.count, blob))
  }

  get latest() {
    return this.chunks[this.count - 1]
  }

  get latestId() {
    return this.latest?.id ?? -1
  }

  get size() {
    return this.chunks.reduce((acc, chunk) => chunk.size + acc, 0)
  }

  get count() {
    return this.chunks.length
  }

  get blobs() {
    return this.chunks.map(chunk => chunk.blob)
  }
}
